import React from "react";
import styled from "styled-components";

const Project=({name,tech,link,glink,date,desc,image})=>{
    console.log(tech);
    return(
        <StyledProject>
            <div className="proj">
            <div className="name">{name}</div>
            <div className="image"><img src={image} alt="proj"/></div>
            <div className="date">{date}</div>
            <div className="desc">{desc}</div>
            <div className="buttons">
            <button><a href={link} target="_blank" rel="noreferrer" >Check Project</a></button>
            <button><a href={glink} target="_blank" rel="noreferrer">Github Code</a></button>
            </div>
            {/* <div className="tech">
                {tech.map((t)=>{
                   return <div className="lang">{t}</div>
                })}
            </div> */}
            </div>
        </StyledProject>
    );
}
const StyledProject=styled.div`
margin: 2rem;
.proj{
padding: 1.2rem;
border-radius: 2rem;
height: 30rem;
width:20rem;
border-top: 0.8rem solid #8483bd;
background-color: #d3d3ec;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
color: black;
box-shadow: 2px 2px 20px 1px #8483bd;
 @media screen and (max-width:786px){
     width:15rem;
     height:28rem;
     .tech{
        width:20rem;
     height:28rem;
     }
 }
}
.name{
    font-family: 'Bebas Neue', cursive;
    font-size: 28px;
}
    .image img{
        width:100%;
        height:100%;
    }
    .image{
        margin:1rem 0rem;
    }
    .desc{
        padding:2rem 0rem;
    }
    .buttons button{
        background-color: #8282eb;
        border:none;
        padding: 0.5rem;
        margin: 0.2rem;
        border-radius: 0.3rem;
        transition: 0.4s ease-in-out;
        a{
            color: white;
            text-decoration: none;
            font-size: 1rem;
        }
        &:hover{
            background-color: white;
            a{
                color:#8282eb
            }
        }
    }
    .tech{
        display: flex;
        .lang{
        margin: 0.4rem;
        }
    }
`


export default Project;